<div class="lua-objet-cabinet">
  <lua-icone [iconName]="'location_city'" [color]="lightColors ? 'Blanc' : 'CouleurPrimaire'"></lua-icone>
  <div class="text-container" [ngClass]="{ light: lightColors }">
    <p class="name">{{ name }}</p>
    <small class="address">{{ address }}</small>
  </div>
</div>
